<div class="content-wrapper container-xxl p-0">
  <div class="content-body">
    <app-content-header [contentHeader]="contentHeader"></app-content-header>
    <section class="row">
      <div class="col-xl-3 col-12 mb-2 mb-md-0">
        <ul class="nav nav-pills xl-flex-column md-flex-row nav-left">
          <li class="nav-item mb-1">
            <a [class]="'nav-link d-flex ' + (active_table === 'masterdata' ? 'active' : '')" (click)="active_table = 'masterdata'">
              <i [data-feather]="'user'" class="font-medium-3 mr-1"></i>
              <span class="font-weight-bold">{{ "MASTERDATA" | translate }}</span>
            </a>
          </li>
          <li class="nav-item mb-1">
            <a [class]="'nav-link d-flex ' + (active_table === 'informations' ? 'active' : '')" (click)="active_table = 'informations'">
              <i [data-feather]="'info'" class="font-medium-3 mr-1"></i>
              <span class="font-weight-bold">{{ "INFORMATIONS" | translate }}</span>
            </a>
          </li>
          <li class="nav-item mb-1">
            <a [class]="'nav-link d-flex ' + (active_table === 'contract' ? 'active' : '')" (click)="active_table = 'contract'">
              <i [data-feather]="'box'" class="font-medium-3 mr-1"></i>
              <span class="font-weight-bold">{{ "CONTRACT" | translate }}</span>
            </a>
          </li>
        </ul>
      </div>
      <div class="col-12 col-xl-9">
        <div class="card">
          <div class="card-header">
            <h3 class="card-title" *ngIf="active_table === 'masterdata'">{{ "MASTERDATA" | translate }}</h3>
            <h3 class="card-title" *ngIf="active_table === 'informations'">{{ "INFORMATIONS" | translate }}</h3>
            <h3 class="card-title" *ngIf="active_table === 'contract'">{{ "CONTRACT_DATA" | translate }}</h3>
          </div>
          <!-- masterdata -->
          <div class="card-body" *ngIf="active_table === 'masterdata'" [formGroup]="formGroup">
            <div class="row">
              <div class="form-group col-xl-5 col-md-6 col-12">
                <label for="firstname">{{ "FIRSTNAME" | translate }}<sup class="text-danger">*</sup></label>
                <input type="text" id="firstname" class="form-control {{ fieldHasErrors('firstname') ? 'is-invalid' : '' }}" formControlName="firstname" />
                <div class="invalid-feedback" *ngIf="formGroup.controls.firstname.errors?.required">{{ "ERRORS.INSERT_NAME" | translate }}</div>
                <div class="invalid-feedback" *ngIf="formGroup.controls?.firstname?.errors?.minlength">{{ "MIN" | translate }} 2 {{ "CHARACTERS" | translate }}</div>
                <div class="invalid-feedback" *ngIf="formGroup.controls?.firstname?.errors?.maxlength">{{ "MAX" | translate }} 255 {{ "CHARACTERS" | translate }}</div>
              </div>
              <div class="form-group col-xl-5 col-md-6 col-12">
                <label for="lastname">{{ "LASTNAME" | translate }}<sup class="text-danger">*</sup></label>
                <input type="text" id="lastname" class="form-control {{ fieldHasErrors('lastname') ? 'is-invalid' : '' }}" formControlName="lastname" />
                <div class="invalid-feedback" *ngIf="formGroup.controls.lastname.errors?.required">{{ "ERRORS.INSERT_LASTNAME" | translate }}</div>
                <div class="invalid-feedback" *ngIf="formGroup.controls?.lastname?.errors?.minlength">{{ "MIN" | translate }} 2 {{ "CHARACTERS" | translate }}</div>
                <div class="invalid-feedback" *ngIf="formGroup.controls?.lastname?.errors?.maxlength">{{ "MAX" | translate }} 255 {{ "CHARACTERS" | translate }}</div>
              </div>
              <div class="form-group col-xl-2 col-md-6 col-12">
                <label for="sex">{{ "GENDER" | translate }}</label>
                <select name="sex" id="sex" class="form-control {{ fieldHasErrors('sex') ? 'is-invalid' : '' }}" formControlName="sex">
                  <option value="m">{{ "MALE" | translate }}</option>
                  <option value="f">{{ "FEMALE" | translate }}</option>
                  <option value="o">{{ "OTHER" | translate }}</option>
                </select>
                <div class="invalid-feedback" *ngIf="formGroup.controls.sex.errors?.required">{{ "ERRRORS.INSERT_SEX" | translate }}</div>
              </div>
              <div class="form-group col-xl-4 col-md-6 col-12" [ngClass.xl]="'mb-0'">
                <label for="birthday">{{ "BIRTHDAY" | translate }}</label>
                <input type="date" id="birthday" [max]="min_birthdate" class="form-control {{ fieldHasErrors('birthday') ? 'is-invalid' : '' }}" formControlName="birthday" />
              </div>
              <div class="form-group col-xl-4 col-md-6 col-12 mb-0" *ngIf="user_type !== 'candidate'">
                <label for="email">{{ "USER_OFFICE_EMAIL" | translate }}<sup class="text-danger">*</sup></label>
                <input type="text" id="email" class="form-control {{ fieldHasErrors('email') ? 'is-invalid' : '' }}" formControlName="email" />
                <div class="invalid-feedback" *ngIf="formGroup.controls.email.errors?.required">{{ "ERRORS.INSERT_OFFICE_EMAIL" | translate }}</div>
              </div>
              <div class="form-group col-xl-4 col-md-6 col-12 pt-2 mt-05 mb-0" *ngIf="user_type === 'employee' && hasCapability('send_welcome_email')">
                <div class="d-flex align-items-center">
                  <label for="sendWelcomeEmail" class="mr-075 mb-0">{{ "SEND_WELCOME_EMAIL" | translate }}</label>
                  <div class="custom-control custom-control-primary custom-switch w-fit ml-1">
                    <input id="sendWelcomeEmail" type="checkbox" checked class="custom-control-input" formControlName="send_welcome_email" />
                    <label class="custom-control-label" for="sendWelcomeEmail"></label>
                  </div>
                </div>
              </div>
              <div class="form-group col-xl-6 col-md-6 col-12" *ngIf="user_type === 'candidate'">
                <label for="private_email2">{{ "PRIVATE_EMAIL" | translate }}<sup class="text-danger">*</sup></label>
                <input type="email" id="private_email2" class="form-control {{ fieldHasErrors('private_email') ? 'is-invalid' : '' }}" formControlName="private_email" />
              </div>
            </div>
            <div class="row mt-3 border-top pt-3" [formGroup]="addressResidence_FormGroup">
              <h4 class="col-12 mb-1">{{ "RESIDENCE_ADDRESS" | translate }}</h4>
              <div class="form-group col-xl-8 col-md-6 col-12">
                <label for="street">{{ "ADDRESS_STREET" | translate }}<sup *ngIf="user_type !== 'candidate'" class="text-danger">*</sup></label>
                <input
                  type="text"
                  id="street"
                  [placeholder]="'ADDRESS_STREET_PLACEHOLDER' | translate"
                  class="form-control {{ fieldHasErrors('street', addressResidence_FormGroup) ? 'is-invalid' : '' }}"
                  formControlName="street"
                />
                <div class="invalid-feedback" *ngIf="addressResidence_FormGroup.controls.street.errors?.required">{{ "ERRORS.INSERT_ADDRESS" | translate }}</div>
              </div>
              <div class="col-xl-4 col-md-6 col-12 form-group" *ngIf="addressResidence_FormGroup.value.external">
                <label for="country">{{ "COUNTRY" | translate }}<sup class="text-danger">*</sup></label>
                <ng-select id="country" [items]="nationsWithCodes" bindLabel="name" bindValue="code" [clearable]="false" formControlName="country" [ngClass]="fieldHasErrors('country') ? 'is-invalid' : ''"></ng-select>
              </div>
              <div class="form-group col-xl-4 col-md-6 col-12" *ngIf="!addressResidence_FormGroup.value.external">
                <label for="zipcode">{{ "ADDRESS_ZIPCODE" | translate }}<sup *ngIf="user_type !== 'candidate'" class="text-danger">*</sup></label>
                <input
                  type="text"
                  id="zipcode"
                  [placeholder]="'ADDRESS_ZIPCODE_PLACEHOLDER' | translate"
                  class="form-control {{ fieldHasErrors('zipcode', addressResidence_FormGroup) ? 'is-invalid' : '' }}"
                  formControlName="zipcode"
                />
                <div class="invalid-feedback" *ngIf="addressResidence_FormGroup.controls.zipcode.errors?.required">{{ "ERRORS.INSERT_ZIP_CODE" | translate }}</div>
                <div class="invalid-feedback" *ngIf="addressResidence_FormGroup.controls?.zipcode?.errors?.minlength">{{ "MIN" | translate }} 5 {{ "CHARACTERS" | translate }}</div>
                <div class="invalid-feedback" *ngIf="addressResidence_FormGroup.controls?.zipcode?.errors?.maxlength">{{ "MAX" | translate }} 5 {{ "CHARACTERS" | translate }}</div>
              </div>
              <div class="form-group col-xl-6 col-md-6 col-12" *ngIf="!addressResidence_FormGroup.value.external">
                <label for="city">{{ "CITY" | translate }}<sup *ngIf="user_type !== 'candidate'" class="text-danger">*</sup></label>
                <ng-select
                  bindValue="id"
                  bindLabel="nice_name"
                  id="city"
                  class="{{ fieldHasErrors('city') ? 'is-invalid' : '' }}"
                  formControlName="city"
                  [closeOnSelect]="true"
                  [clearable]="false"
                  [openOnEnter]="false"
                  [virtualScroll]="true"
                  (change)="setResidenceProvinces()"
                  [items]="_citiesService.list"
                ></ng-select>
                <div class="invalid-feedback" *ngIf="addressResidence_FormGroup.controls.zipcode.errors?.required">{{ "ERRORS.INSERT_ONE_CITY" | translate }}</div>
              </div>
              <div class="form-group col-xl-6 col-md-6 col-12" *ngIf="!addressResidence_FormGroup.value.external">
                <label for="province">{{ "ADDRESS_PROVINCE" | translate }}<sup *ngIf="user_type !== 'candidate'" class="text-danger">*</sup></label>
                <ng-select
                  bindValue="id"
                  bindLabel="nice_name"
                  id="province"
                  formControlName="province"
                  class="{{ fieldHasErrors('province') ? 'is-invalid' : '' }}"
                  [closeOnSelect]="true"
                  [clearable]="false"
                  [openOnEnter]="false"
                  [virtualScroll]="true"
                  [items]="_citiesService.list"
                ></ng-select>
                <div class="invalid-feedback" *ngIf="addressResidence_FormGroup.controls.province.errors?.required">{{ "ADDRESS_PROVINCE_REQUIRED" | translate }}</div>
              </div>
              <div class="form-group col-md-6 col-12 d-flex align-items-center">
                <small class="mr-1">{{ "EXTERNAL_ADDRESS_QUESTION" | translate }}</small>
                <div class="custom-control custom-control-primary custom-switch">
                  <input type="checkbox" class="custom-control-input" id="customSwitchExternal" formControlName="external" (change)="manageExternalSiteResidence()" />
                  <label class="custom-control-label" for="customSwitchExternal"> </label>
                </div>
              </div>
            </div>
          </div>

          <!-- informations -->
          <div class="card-body" *ngIf="active_table === 'informations'" [formGroup]="formGroup">
            <div class="row">
              <div class="form-group col-xl-6 col-md-6 col-12">
                <label for="province">{{ "BIRTH_PLACE" | translate }}</label>
                <ng-select
                  bindValue="id"
                  bindLabel="nice_name"
                  id="birth_place"
                  class="{{ fieldHasErrors('birth_place') ? 'is-invalid' : '' }}"
                  formControlName="birth_place"
                  [closeOnSelect]="true"
                  [clearable]="false"
                  [openOnEnter]="false"
                  [virtualScroll]="true"
                  [items]="_citiesService.list"
                ></ng-select>
              </div>
              <div class="form-group col-xl-6 col-md-6 col-12">
                <label for="working_city">{{ "WORKING_CITY" | translate }}</label>
                <ng-select
                  bindValue="id"
                  bindLabel="nice_name"
                  id="working_city"
                  formControlName="working_city"
                  [items]="_citiesService.list"
                  class="{{ fieldHasErrors('working_city') ? 'is-invalid' : '' }}"
                  [closeOnSelect]="true"
                  [clearable]="false"
                  [openOnEnter]="false"
                  [virtualScroll]="true"
                ></ng-select>
              </div>
              <div class="form-group col-xl-6 col-md-6 col-12">
                <label for="site">{{ "JOB_SITE" | translate }}</label>
                <ng-select
                  bindValue="id"
                  bindLabel="name"
                  id="site"
                  class="{{ fieldHasErrors('site') ? 'is-invalid' : '' }}"
                  formControlName="site"
                  [closeOnSelect]="true"
                  [clearable]="false"
                  [openOnEnter]="false"
                  [virtualScroll]="true"
                  [items]="_jobSiteService.list"
                ></ng-select>
              </div>
              <div class="form-group col-xl-6 col-md-6 col-12">
                <label for="reference_hr">{{ "HR_REFERENCE" | translate }}</label>
                <ng-select
                  bindValue="hash"
                  bindLabel="name"
                  id="reference_hr"
                  formControlName="reference_hr"
                  class="{{ fieldHasErrors('reference_hr') ? 'is-invalid' : '' }}"
                  [closeOnSelect]="true"
                  [multiple]="false"
                  [searchable]="true"
                  [clearable]="false"
                  [openOnEnter]="false"
                  [virtualScroll]="true"
                  [items]="hr_list"
                ></ng-select>
              </div>
              <div [class]="'form-group col-12 col-md-6 col-xl-' + (user_type === 'candidate' ? 4 : 6)">
                <label for="phone">{{ "PHONE" | translate }}<sup class="text-danger">*</sup></label>
                <input type="tel" id="phone" maxlength="15" class="form-control {{ fieldHasErrors('phone') ? 'is-invalid' : '' }}" formControlName="phone" />
                <div class="invalid-feedback" *ngIf="formGroup.controls.phone.errors?.required">{{ "ERRORS.INSERT_PHONE" | translate }}</div>
                <div class="invalid-feedback" *ngIf="formGroup.controls?.phone?.errors?.minlength">{{ "MIN" | translate }} 9 {{ "CHARACTERS" | translate }}</div>
                <div class="invalid-feedback" *ngIf="formGroup.controls?.phone?.errors?.maxlength">{{ "MAX" | translate }} 15 {{ "CHARACTERS" | translate }}</div>
              </div>
              <div class="form-group col-xl-6 col-md-6 col-12" *ngIf="user_type !== 'candidate'">
                <label for="private_email">{{ "PRIVATE_EMAIL" | translate }}<sup class="text-danger">*</sup></label>
                <input type="email" id="private_email" class="form-control {{ fieldHasErrors('private_email') ? 'is-invalid' : '' }}" formControlName="private_email" />
                <div class="invalid-feedback" *ngIf="formGroup.controls.private_email.errors?.required">{{ "ERRORS.INSERT_PRIVATE_EMAIL" | translate }}</div>
              </div>
              <div [class]="'form-group col-12 col-md-6 col-xl-' + (user_type === 'candidate' ? 4 : 6)">
                <label for="fiscal_code">{{ "FISCAL_CODE" | translate }}</label>
                <input type="text" id="fiscal_code" class="form-control {{ fieldHasErrors('fiscal_code') ? 'is-invalid' : '' }}" formControlName="fiscal_code" />
              </div>
              <div class="form-group col-xl-6 col-md-6 col-12">
                <label for="nationality">{{ "NATIONALITY" | translate }}</label>
                <ng-select id="nationality" class="{{ fieldHasErrors('nationality') ? 'is-invalid' : '' }}" formControlName="nationality">
                  <ng-option *ngFor="let nationality of nationalities_list" [value]="nationality">{{ nationality }}</ng-option>
                </ng-select>
              </div>
              <div class="form-group col-xl-6 col-md-6 col-12">
                <label for="civil_status">{{ "CIVIL_STATUS" | translate }}</label>
                <ng-select
                  bindValue="name"
                  bindLabel="name"
                  id="civil_status"
                  class="{{ fieldHasErrors('site') ? 'is-invalid' : '' }}"
                  formControlName="civil_status"
                  [closeOnSelect]="true"
                  [clearable]="false"
                  [openOnEnter]="false"
                  [virtualScroll]="true"
                  [items]="_userService.civil_status"
                ></ng-select>
              </div>
              <div class="form-group col-xl-6 col-md-6 col-12">
                <label for="child_number">{{ "CHILD_NUMBER" | translate }}</label>
                <input type="number" min="0" id="child_number" class="form-control {{ fieldHasErrors('child_number') ? 'is-invalid' : '' }}" formControlName="child_number" (change)="handlerChangeChild()" />
              </div>
              <div class="form-group col-xl-8 col-12">
                <label for="iban">{{ "IBAN" | translate }}</label>
                <input type="text" id="iban" class="form-control {{ fieldHasErrors('iban') ? 'is-invalid' : '' }}" formControlName="iban" />
              </div>
              <div class="form-group col-xl-4 col-md-6 col-12 pt-2 mt-05">
                <div class="d-flex align-items-center">
                  <label for="need_assets" class="mb-0">{{ "NEED_ASSETS" | translate }}</label>
                  <div class="custom-control custom-control-success custom-switch w-fit ml-4">
                    <input type="checkbox" class="custom-control-input" id="need_assets" formControlName="need_assets" />
                    <label class="custom-control-label" for="need_assets">{{ (formGroup.get("need_assets").value ? "YES" : "NO") | translate }}</label>
                  </div>
                </div>
              </div>
              <div class="form-group col-xl-4 col-md-6 col-12">
                <label for="figure">{{ "FIGURE" | translate }}<sup class="text-danger">*</sup></label>
                <ng-select
                  bindValue="id"
                  bindLabel="name"
                  id="figure"
                  class="{{ fieldHasErrors('figure') ? 'is-invalid' : '' }}"
                  formControlName="figure"
                  [closeOnSelect]="true"
                  [clearable]="false"
                  [openOnEnter]="false"
                  [virtualScroll]="true"
                  [items]="_userFigureService.list"
                ></ng-select>
                <div class="invalid-feedback" *ngIf="formGroup.controls.figure.errors?.required">{{ "ERRORS.FIELD_FIGURE" | translate }}</div>
              </div>
              <div class="form-group col-xl-4 col-md-6 col-12" *ngIf="hasCapability('assign_role')">
                <label for="role">{{ "ROLE" | translate }}<sup class="text-danger">*</sup></label>
                <ng-select
                  id="role"
                  class="{{ fieldHasErrors('role') ? 'is-invalid' : '' }}"
                  formControlName="role"
                  bindLabel="name"
                  bindValue="id"
                  [closeOnSelect]="true"
                  [clearable]="false"
                  [openOnEnter]="false"
                  [virtualScroll]="true"
                  [items]="_roleService.list"
                >
                </ng-select>
                <div class="invalid-feedback" *ngIf="formGroup.controls.role.errors?.required">{{ "ERRORS.FIELD_ROLE" | translate }}</div>
              </div>
              <div class="form-group col-xl-4 col-md-6 col-12">
                <label for="badge_number">{{ "BADGE_NUMBER" | translate }}</label>
                <input type="text" maxlength="10" id="badge_number" class="form-control {{ fieldHasErrors('badge_number') ? 'is-invalid' : '' }}" formControlName="badge_number" />
              </div>
            </div>
          </div>
          <!-- contract -->
          <div class="card-body" *ngIf="active_table === 'contract'">
            <div class="row">
              <div [class]="'form-group col-12 col-md-6 col-xl-' + (_manageContract.typeIsApprendistato || _manageContract.typeIsStage ? 4 : 6)">
                <label for="contract_id">{{ "CONTRACT_TYPE" | translate }}<sup class="text-danger">*</sup></label>
                <ng-select
                  id="contract_id"
                  [items]="_contractService.list"
                  bindLabel="name"
                  bindValue="id"
                  [closeOnSelect]="true"
                  [clearable]="false"
                  [(ngModel)]="_manageContract.data.contract"
                  (change)="_manageContract.changeContract($event)"
                  class="{{ !_manageContract.data.contract ? 'is-invalid' : '' }}"
                >
                </ng-select>
              </div>
              <div class="form-group col-12 col-md-6 col-xl-4" *ngIf="_manageContract.typeIsApprendistato">
                <label for="contract_level">{{ "DURATION" | translate }}<sup class="text-danger">*</sup></label>
                <input
                  type="number"
                  min="1"
                  max="36"
                  [defaultValue]="3"
                  class="form-control {{ !_manageContract.contractDuration ? 'is-invalid' : '' }}"
                  [(ngModel)]="_manageContract.contractDuration"
                  [ngModelOptions]="{ standalone: true }"
                  (change)="_manageContract.updateData()"
                />
              </div>
              <div [class]="'form-group col-12 col-md-6 col-xl-' + (_manageContract.typeIsApprendistato ? 4 : 6)" *ngIf="!_manageContract.typeIsStage">
                <label for="contract_level">{{ "LEVEL" | translate }}<sup class="text-danger">*</sup></label>
                <ng-select
                  *ngIf="_manageContract.levels_for_select.length > 0"
                  id="contract_level"
                  class="{{ !_manageContract.data.level ? 'is-invalid' : '' }}"
                  [(ngModel)]="_manageContract.data.level"
                  [closeOnSelect]="true"
                  [clearable]="false"
                  [openOnEnter]="false"
                  [virtualScroll]="true"
                  (change)="_manageContract.changeLevel(true, false)"
                >
                  <ng-option *ngFor="let lvl of _manageContract.levels_for_select" [value]="lvl">{{ lvl }}</ng-option>
                </ng-select>
                <select *ngIf="_manageContract.levels_for_select.length < 1" disabled class="form-control"></select>
              </div>
              <div class="form-group col-12 col-md-6 col-xl-4" *ngIf="_manageContract.typeIsApprendistato || _manageContract.typeIsStage">
                <label for="contract_level">{{ "TUTOR" | translate }}<sup class="text-danger">*</sup></label>
                <ng-select [closeOnSelect]="true" [clearable]="false" [(ngModel)]="_manageContract.data.tutor_hash" class="{{ !_manageContract.data.tutor_hash ? 'is-invalid' : '' }}">
                  <ng-option *ngFor="let tutor of _manageContract.tutors" [value]="tutor.hash">{{ tutor.complete_name }}</ng-option>
                </ng-select>
              </div>
              <div class="form-group col-xl-4 col-md-6 col-12" *ngIf="!_manageContract.typeIsStage">
                <label for="contract_trial">{{ "CONTRACT_TRIAL_DAYS" | translate }}<sup class="text-danger">*</sup></label>
                <input readonly type="number" id="contract_trial" class="form-control" [(ngModel)]="_manageContract.data.trial" />
              </div>
              <div class="form-group col-xl-4 col-md-6 col-12">
                <label for="contract_role">{{ "DUTY" | translate }}<sup class="text-danger">*</sup></label>
                <ng-select
                  bindValue="id"
                  bindLabel="name"
                  id="contract_role"
                  [(ngModel)]="_manageContract.data.role"
                  [closeOnSelect]="true"
                  [clearable]="false"
                  [openOnEnter]="false"
                  class="{{ !_manageContract.data.role ? 'is-invalid' : '' }}"
                  [virtualScroll]="true"
                  [items]="_userFigureService.list"
                ></ng-select>
              </div>
              <div class="form-group col-xl-4 col-md-6 col-12">
                <label for="contract_program">{{ "CONTRACT_PROGRAM" | translate }}<sup class="text-danger">*</sup></label>
                <ng-select id="contract_program" [items]="_contractService.programs" bindLabel="label" bindValue="value" [closeOnSelect]="true" [clearable]="false" [(ngModel)]="_manageContract.data.program"> </ng-select>
              </div>
              <div [class]="'form-group col-12 col-md-6 col-xl-' + (_manageContract.typeIsApprendistato || _manageContract.typeIsStage ? 4 : 6)">
                <label for="contract_start_date">{{ "START_DATE" | translate }}<sup class="text-danger">*</sup></label>
                <input
                  type="date"
                  id="contract_start_date"
                  class="form-control {{ !_manageContract.data.start_date ? 'is-invalid' : '' }}"
                  (change)="_manageContract.updateData('notRal')"
                  [(ngModel)]="_manageContract.data.start_date"
                />
              </div>
              <div [class]="'form-group col-12 col-md-6 col-xl-' + (_manageContract.typeIsApprendistato || _manageContract.typeIsStage ? 4 : 6)">
                <label for="contract_end_date">{{ "END_DATE" | translate }}<sup class="text-danger">*</sup></label>
                <input
                  type="date"
                  id="contract_end_date"
                  [readOnly]="_manageContract.typeIsIndeterminate || _manageContract.typeIsApprendistato"
                  (change)="_manageContract.updateData('notRal')"
                  class="form-control {{ !_manageContract.data.end_date && !_manageContract.typeIsIndeterminate ? 'is-invalid' : '' }}"
                  [(ngModel)]="_manageContract.data.end_date"
                />
              </div>
            </div>
            <div class="row">
              <div class="form-group col-12">
                <h4 class="mb-0 mt-2">{{ "EMPLOYEE_COSTS" | translate }}</h4>
              </div>
              <!-- soglie per il prossimo livello -->
              <div class="form-group col-12" *ngIf="_manageContract.current_lvl && _manageContract.next_lvl && !_manageContract.typeIsStage && _manageContract.data.level != 'B3'">
                <p class="mb-0 font-small-4">
                  {{ "RAL_FOR_LEVEL" | translate }} <strong>{{ _manageContract.next_lvl.level }}</strong
                  >&nbsp; <em>{{ _utilService.addDotsToNumber(_manageContract.next_lvl.salary_yearly_gross) }}&euro;</em>
                </p>
              </div>
              <div class="form-group col-xl-6 col-md-6 col-12" *ngIf="!_manageContract.typeIsStage">
                <label for="salary_yearly_gross">{{ "SALARY_YEARLY_GROSS" | translate }}<sup class="text-danger">*</sup></label>
                <div class="input-group input-group-merge {{ _manageContract.data.contract && !_manageContract.data.salary_yearly_gross ? 'is-invalid' : '' }}">
                  <div class="input-group-prepend">
                    <span class="input-group-text" [ngClass]="!_manageContract.data.contract ? 'bg-readonly' : ''">&euro;</span>
                  </div>
                  <input *ngIf="!_manageContract.data.contract; else ralInput" readonly type="text" [(ngModel)]="_manageContract.data.salary_yearly_gross" class="form-control" />
                  <ng-template #ralInput>
                    <input
                      type="text"
                      id="salary_yearly_gross"
                      class="form-control bg-white"
                      [(ngModel)]="_manageContract.data.salary_yearly_gross"
                      [ngClass]="!_manageContract.data.salary_yearly_gross ? 'is-invalid' : ''"
                      (change)="transformRal($any($event.target).value)"
                    />
                  </ng-template>
                </div>
              </div>
              <div class="form-group col-xl-3 col-md-6 col-12" *ngIf="!_manageContract.typeIsStage">
                <label for="bonus">{{ "MONTHLY_BONUSES" | translate }}</label>
                <div class="input-group input-group-merge">
                  <div class="input-group-prepend">
                    <span class="input-group-text">&euro;</span>
                  </div>
                  <input
                    type="text"
                    [readOnly]="!_manageContract.current_lvl || !_manageContract.next_lvl"
                    id="bonus"
                    (change)="_manageContract.updateData()"
                    min="0"
                    class="form-control bg-white"
                    step="5"
                    [(ngModel)]="_manageContract.data.bonus"
                  />
                </div>
              </div>
              <div class="form-group col-xl-3 col-md-6 col-12" *ngIf="!_manageContract.typeIsStage">
                <label for="production_bonus">{{ "PRODUCTION_BONUS" | translate }}</label>
                <div class="input-group input-group-merge">
                  <div class="input-group-prepend">
                    <span class="input-group-text">&euro;</span>
                  </div>
                  <input
                    type="text"
                    [readOnly]="!_manageContract.current_lvl || !_manageContract.next_lvl"
                    id="production_bonus"
                    (change)="_manageContract.updateData()"
                    min="0"
                    class="form-control bg-white"
                    step="5"
                    [(ngModel)]="_manageContract.data.production_bonus"
                  />
                </div>
              </div>
              <div class="col-12"></div>
              <div class="form-group col-xl-4 col-md-6 col-12">
                <label for="net_monthly_12">{{ _manageContract.typeIsStage ? ("SALARY_MONTH" | translate) : ("SALARY_MONTH_12" | translate) }}</label>
                <div class="input-group input-group-merge">
                  <div class="input-group-prepend">
                    <span class="input-group-text {{ !_manageContract.typeIsStage ? 'bg-readonly' : '' }}">&euro;</span>
                  </div>
                  <input
                    [readOnly]="!_manageContract.typeIsStage"
                    type="text"
                    id="net_monthly_12"
                    class="form-control"
                    [(ngModel)]="_manageContract.data.net_monthly_12"
                    [value]="_manageContract.data.net_monthly_12"
                    (change)="_manageContract.updateData()"
                  />
                </div>
              </div>
              <div class="form-group col-xl-4 col-md-6 col-12" *ngIf="!_manageContract.typeIsStage">
                <label for="net_monthly_13">{{ "SALARY_MONTH_13" | translate }}</label>
                <div class="input-group input-group-merge">
                  <div class="input-group-prepend">
                    <span class="input-group-text bg-readonly">&euro;</span>
                  </div>
                  <input readonly="readonly" type="text" id="net_monthly_13" class="form-control" [value]="_manageContract.data.net_monthly_13" />
                </div>
              </div>
              <div class="form-group col-xl-4 col-md-6 col-12" *ngIf="!_manageContract.typeIsStage">
                <label for="total_monthly_13">{{ "TOTAL_SALARY_MONTH_13" | translate }}</label>
                <div class="input-group input-group-merge">
                  <div class="input-group-prepend">
                    <span class="input-group-text bg-readonly">&euro;</span>
                  </div>
                  <input readonly="readonly" type="text" id="total_monthly_13" class="form-control" [value]="_manageContract.data.total_net_monthly_13" />
                </div>
              </div>
            </div>
            <div class="row" *ngIf="!_manageContract.typeIsStage">
              <div class="form-group col-12">
                <h4 class="mb-0 mt-2">{{ "BONUS_TICKET" | translate }}</h4>
              </div>
              <div class="form-group col-xl-6 col-md-6 col-12">
                <label for="ticket_card">{{ "TICKET_CARD" | translate }}</label>
                <input type="text" maxlength="7" id="ticket_card" class="form-control" [(ngModel)]="_manageContract.data.ticket_card" />
              </div>
              <div class="form-group col-xl-6 col-md-6 col-12">
                <label for="ticket_type">{{ "TICKET_TYPE" | translate }}</label>
                <select
                  name="ticket_type"
                  id="ticket_type"
                  class="form-control"
                  [(ngModel)]="_manageContract.data.ticket_type"
                  (change)="_manageContract.data.ticket_month_number = _manageContract.data.ticket_type === 'variabile' ? 20 : 0"
                >
                  <option disabled>{{ "TICKET_TYPE" | translate }}</option>
                  <option value="fisso">{{ "STATIC" | translate }}</option>
                  <option value="variabile">{{ "VARIABLE" | translate }}</option>
                </select>
              </div>
              <div class="form-group col-xl-4 col-md-6 col-12">
                <label for="ticket_month_number">{{ "TICKET_MONTH_NUMBER" | translate }}</label>
                <input
                  type="number"
                  (change)="_manageContract.updateData()"
                  [readOnly]="_manageContract.data.ticket_type === 'variabile'"
                  id="ticket_month_number"
                  class="form-control"
                  [(ngModel)]="_manageContract.data.ticket_month_number"
                />
              </div>
              <div class="form-group col-xl-4 col-md-6 col-12">
                <label for="ticket_value">{{ "TICKET_DAILY_VALUE" | translate }}</label>
                <div class="input-group input-group-merge">
                  <div class="input-group-prepend">
                    <span class="input-group-text">&euro;</span>
                  </div>
                  <input type="number" id="ticket_value" (change)="_manageContract.updateData()" class="form-control" [(ngModel)]="_manageContract.data.ticket_value" />
                </div>
              </div>
              <div class="form-group col-xl-4 col-md-6 col-12">
                <label for="total_monthly_13">{{ "TICKET_TOTAL_MONTH" | translate }}</label>
                <div class="input-group input-group-merge">
                  <div class="input-group-prepend">
                    <span class="input-group-text bg-readonly">&euro;</span>
                  </div>
                  <input readonly="readonly" type="text" class="form-control" [value]="_utilService.addDotsToNumber(_manageContract.data.ticket_value * _manageContract.data.ticket_month_number)" />
                </div>
              </div>
            </div>
            <div class="row" [formGroup]="formGroup">
              <div class="form-group col-12">
                <h4 class="mb-0 mt-2">{{ "HOLIDAYS_AND_PERMISSIONS" | translate }}</h4>
              </div>
              <div class="form-group col-xl-6 col-md-6 col-12">
                <label for="absence_holidays">{{ "HOLIDAYS_NOT_TAKEN" | translate }} ({{ "DAYS" | translate }})</label>
                <input type="number" id="absence_holidays" class="form-control" formControlName="residual_holidays" />
              </div>
              <div class="form-group col-xl-6 col-md-6 col-12">
                <label for="absence_permissions">{{ "PERMISSION_NOT_TAKEN" | translate }} ({{ "HOURS" | translate }})</label>
                <input type="number" id="absence_permissions" class="form-control" formControlName="residual_permissions" />
              </div>
            </div>

            <div class="row">
              <div class="form-group col-12">
                <h4 class="mb-0 mt-2">{{ "UPLOAD_CONTRACT" | translate }}</h4>
              </div>
              <div class="form-group col-xl-6 col-md-6 col-12">
                <fieldset>
                  <div class="custom-file">
                    <input class="custom-file-input" type="file" lang="it" accept="application/pdf" (change)="handlerChangeFileInput($event)" />
                    <label *ngIf="!fileName" class="custom-file-label">{{ "SELECT_FILE" | translate }}</label>
                    <label *ngIf="fileName && fileName.length > 0" class="custom-file-label">{{ fileName }}</label>
                  </div>
                </fieldset>
              </div>
            </div>
          </div>
          <div class="card-footer d-flex" [ngClass.sm]="'flex-column'" [ngClass.xl]="'align-items-end'" [ngClass.md]="'align-items-end'">
            <div [ngClass.xl]="'flex-basis-50'" [ngClass.md]="'flex-basis-50'" [ngClass.sm]="'mb-1'">
              <div id="contract-daily-cost" *ngIf="active_table === 'contract'">
                {{ "TOTAL_SALARY_DAILY" | translate }}
                <strong>&euro; {{ _manageContract.data.total_daily }}</strong>
              </div>
            </div>
            <div [ngClass.xl]="'flex-basis-50 text-right'" [ngClass.md]="'flex-basis-100 text-right'" [ngClass.sm]="'d-flex flex-column'">
              <button type="button" class="btn btn-primary" (click)="!buttonIsEnabled() ? checkEmptyFieldAlert() : submit()">
                {{ "SAVE" | translate }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</div>
